import React from 'react';

import { Box, Collapse, TableCell, TableRow } from '@mui/material';

import { AutoMedicalClaimsClaimsTable } from './AutoMedicalClaimsClaimsTable';
import { sortedClaimsForRule } from './ruleHitsHelpers';
import { MedicalClaim, RuleHit } from './types';

type AutoMedicalClaimsRuleRowProps = {
  rule: RuleHit;
  claimsById: Record<number, MedicalClaim>;
  isExpanded: boolean;
  onToggleRuleClaims: (ruleId: string) => void;
};

export const AutoMedicalClaimsRuleRow = ({
  rule,
  claimsById,
  isExpanded,
  onToggleRuleClaims,
}: AutoMedicalClaimsRuleRowProps) => {
  const claims = sortedClaimsForRule(rule.claimIds, claimsById);

  return (
    <>
      <TableRow
        hover
        onClick={() => onToggleRuleClaims(rule.id)}
        className="auto-medical-claims-rule-row"
      >
        <TableCell className="auto-medical-claims-rule-expand-cell">
          {isExpanded ? '▼' : '▶'}
        </TableCell>
        <TableCell>
          <Box component="span" className="auto-medical-claims-rule-ident">
            {rule.ruleIdent}
          </Box>
        </TableCell>
        <TableCell>
          {rule.modifier ? (
            <div className="auto-medical-claims-rule-modifier">
              {rule.modifier}
            </div>
          ) : (
            <div className="auto-medical-claims-rule-modifier-empty">-</div>
          )}
        </TableCell>
        <TableCell>
          <div className="auto-medical-claims-rule-name">{rule.ruleName}</div>
        </TableCell>
        <TableCell>
          <Box component="span" className="auto-medical-claims-claim-count">
            {`${rule.claimIds.length} ${
              rule.claimIds.length === 1 ? 'claim' : 'claims'
            }`}
          </Box>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell
          colSpan={5}
          className={`auto-medical-claims-claim-row-cell ${
            isExpanded ? 'auto-medical-claims-claim-row-cell--expanded' : ''
          }`}
        >
          <Collapse in={isExpanded} timeout="auto" unmountOnExit>
            <Box className="auto-medical-claims-claim-detail">
              <AutoMedicalClaimsClaimsTable claims={claims} />
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};
